import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'

interface ToggleGroupWrapperProps {
  disabled?: boolean
}

export const ToggleGroupWrapper = styled.div<ToggleGroupWrapperProps>`
  display: inline-flex;
  column-gap: ${Spacing.S2};
  height: 42px;
  padding: ${Spacing.S4};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}
`
